import './style.scss';
import { Box, Typography } from '@mui/material';
import { useLanguageContext } from '../../../../../contexts/LanguageContext';
import ScrollableX from '../../../../../components/ScrollableX';
import Image from '../../../../../components/Image';


interface IGalleryProps {
    items: any[];
    showTitle?: boolean;
    showDescription?: boolean;
    size?: 'small' | 'medium' | 'large';
}


const Gallery: React.FC<IGalleryProps> = ({
    items,
    showTitle = true,
    showDescription = true,
    size = 'large'
}) => {
    const { translate } = useLanguageContext();


    return <Box className='grid-content-section' id='gallery'>
        {showTitle && <Typography variant='subtitle1' className='gallery-title'>{translate('galleryTitle')}</Typography>}
        {showDescription && <Typography variant='subtitle2' className='gallery-description'>{translate('galleryDescription')}</Typography>}

        <Box className='gallery-items'>
            <ScrollableX hasContainer={false}>
                {
                    items.map((r, index) => {
                        return <Image src={r} size={size} key={index} />;
                    })
                }
            </ScrollableX>
        </Box>
    </Box>;
}

export default Gallery;